import { Filter } from "@/components/filter/_types";

export interface FilterGroup {
  label: string | undefined;
  filters: Filter<unknown, unknown>[];
}

export function groupFilters(filters: Filter<unknown, unknown>[]): FilterGroup[] {
  const groups: FilterGroup[] = [];

  for (const filter of filters) {
    const lastGroup = groups[groups.length - 1];

    if (lastGroup && lastGroup.label === filter.group) {
      lastGroup.filters.push(filter);
    } else {
      groups.push({ label: filter.group, filters: [filter] });
    }
  }

  return groups;
}
